import axios from 'axios'
import baseUrl from './setBaseUrl.ts'
import { Message } from 'element-ui'
import router from '../../router/index.js'

const myaxios = {}
myaxios.install = function (Vue) {
  axios.defaults.withCredentials = true
  axios.defaults.baseURL = baseUrl
  // 进行全局设置
  //   axios.defaults.headers.common.Authorization = window.localStorage.getItem('token');
  // 请求拦截器
  axios.interceptors.request.use((config) => {
    if (config.url !== '/login') {
      // 进行局部设置
      // eslint-disable-next-line max-len
      // config.headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'token': window.localStorage.getItem('token') };
      // eslint-disable-next-line max-len
      // config.headers = { 'Content-Type': 'application/json', 'token': window.localStorage.getItem('token') };
      // eslint-disable-next-line no-param-reassign
      // config.headers.token = window.localStorage.getItem('token')
      config.headers.token = window.localStorage.getItem('token')
    }
    // console.log(config)
    return config
  })
  // 响应拦截器
  axios.interceptors.response.use(function (response) {
    // console.log(response)
    // console.log(router)
    if (response.data.code == '40100') {
      Message.error({
        message: '未登录，请先登录~ ',
        duration: '1000'
      }
      )
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo')
      router.replace({
        path: '/login'

      })
      // setTimeout(() => {
      //   window.location.href = '/login'
      // }, 2000)
    }
    if (response.data.code == '40101') {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo')
    }
    return response
  }, function (error) {
    return Promise.reject(error)
  })
  Vue.prototype.$http = axios
}

export default myaxios



// WEBPACK FOOTER //
// ./src/assets/js/myaxios.js